import React, { useEffect, useState } from 'react';
import { diffObjects, getObjectHash, safeJSON } from '@iotv/datamodel-core';
const debug = process.env.REACT_APP_DEBUG && false;
const localStorageMainKey = 'columnVisibility';
/** stores and provides the column visiblity settings as set by the user for a specific table instance, and object type */
export const useColumnVisibilityForDataGrid = ({ dataTableReference, objectTypeId, viewType, externalColumnVisibility, }) => {
    //https://mui.com/x/react-data-grid/column-visibility/
    const currentLocalStorageKey = getLocalStorageKey({ dataTableReference, objectTypeId, viewType });
    const [localStorageKey, setLocalStorageKey] = useState(currentLocalStorageKey);
    const externalColumnVisibilityHash = getObjectHash(externalColumnVisibility);
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({});
    useEffect(() => {
        debug && console.log('used effect on ', { dataTableReference, objectTypeId, viewType });
        const derivedLocalStorageKey = getLocalStorageKey({ dataTableReference, objectTypeId, viewType });
        derivedLocalStorageKey && setLocalStorageKey(derivedLocalStorageKey);
        const storedSettings = get(derivedLocalStorageKey);
        if (storedSettings) {
            debug && console.log('using stored settings', storedSettings);
            setColumnVisibilityModel(storedSettings);
        }
        else {
            debug && console.log(`no stored settings with ${derivedLocalStorageKey}, using`, externalColumnVisibility);
            if (externalColumnVisibility) {
                setColumnVisibilityModel(externalColumnVisibility);
            }
        }
    }, [dataTableReference, objectTypeId, viewType, externalColumnVisibilityHash]);
    // Removed as overrides stored settings, but calling components should not need to change column visibility
    /*
   useEffect( () => {
    debug && console.log(`useColumnVisibilityForDataGrid using effect on`, externalColumnVisibility )
    externalColumnVisibility && setColumnVisibilityModel( externalColumnVisibility)
    }, [ externalColumnVisibilityHash ])
  */
    const onColumnVisibilityModelChange = (newModel, details) => {
        debug && console.log(`visibility diff`, diffObjects(columnVisibilityModel, newModel));
        debug && console.log(`visibility details`, details);
        set(localStorageKey, newModel);
        setColumnVisibilityModel(newModel);
    };
    debug && console.log(`useColumnVisibilityForDataGrid externalColumnVisibitiy`, externalColumnVisibility);
    return [columnVisibilityModel, setColumnVisibilityModel, onColumnVisibilityModelChange];
};
/** LOCAL STORAGE HELPERS ONLY - NOTHING TO SEE */
const splitLocalStorageKey = (localStorageKey) => {
    const [dataTableReference, objectTypeId, viewType] = localStorageKey.split('/');
    return { dataTableReference, objectTypeId, viewType };
};
/** gets  */
const getLocalStorageKey = ({ dataTableReference, objectTypeId, viewType, }) => {
    const safeDataTableReference = dataTableReference?.replaceAll('/', '_');
    return objectTypeId ? `${safeDataTableReference ?? 'default'}/${objectTypeId}/${viewType}` : undefined;
};
const get = (localStorageKey) => {
    let gridColumnVisibilityModel = undefined;
    if (localStorageKey) {
        const { dataTableReference, objectTypeId, viewType } = splitLocalStorageKey(localStorageKey);
        const sectionStr = localStorage.getItem(localStorageMainKey);
        const objectAtSection = safeJSON.parse(sectionStr);
        debug && console.log(`got section ${localStorageKey} as `, objectAtSection);
        gridColumnVisibilityModel = objectAtSection && objectAtSection?.[dataTableReference]?.[objectTypeId]?.[viewType];
    }
    return gridColumnVisibilityModel;
};
const set = (localStorageKey, gridColumnVisibilityModel) => {
    if (localStorageKey) {
        const { dataTableReference, objectTypeId, viewType } = splitLocalStorageKey(localStorageKey);
        const existingSectionStr = localStorage.getItem(localStorageMainKey);
        const objectAtSection = (safeJSON.parse(existingSectionStr) ?? {});
        if (!objectAtSection[dataTableReference]) {
            objectAtSection[dataTableReference] = {};
        }
        if (!objectAtSection[dataTableReference][objectTypeId]) {
            objectAtSection[dataTableReference][objectTypeId] = {};
        }
        if (!objectAtSection[dataTableReference][objectTypeId][viewType]) {
            objectAtSection[dataTableReference][objectTypeId][viewType] = {};
        }
        debug && console.log(`settting ${localStorageKey} from`, objectAtSection[dataTableReference][objectTypeId][viewType], ` to  `, gridColumnVisibilityModel);
        Object.assign(objectAtSection[dataTableReference][objectTypeId][viewType], gridColumnVisibilityModel); // because it is feasible that additional columns are already set but not avaiable here
        const sectionStr = JSON.stringify(objectAtSection);
        debug && console.log(`setting model`, objectAtSection);
        localStorage.setItem(localStorageMainKey, sectionStr);
    }
    else {
        debug && console.log(`not setting model as no localStorageKey`);
    }
};
